export const VendorErrorParameter = {
  PARAM_UNKNOWN: 'PARAM_UNKNOWN',
  VOLTAGE: 'VOLTAGE',
  CURRENT: 'CURRENT',
  POWER_ACTIVE: 'POWER_ACTIVE',
  POWER_REACTIVE: 'POWER_REACTIVE',
  ENERGY: 'ENERGY',
  FREQUENCY: 'FREQUENCY',
  SOC: 'SOC',
  SOH: 'SOH',
  RESISTANCE: 'RESISTANCE',
  SIGNAL_STRENGTH: 'SIGNAL_STRENGTH',
  TEMPERATURE: 'TEMPERATURE',
  HUMIDITY: 'HUMIDITY',
  PRESSURE: 'PRESSURE',
  CO2: 'CO2',
  VOC: 'VOC',
  ILLUMINANCE: 'ILLUMINANCE',
  VIBRATION: 'VIBRATION',
  ACCELERATION: 'ACCELERATION',
  VELOCITY: 'VELOCITY',
  LATENCY: 'LATENCY',
  TORQUE: 'TORQUE',
  FORCE: 'FORCE',
  ROTATIONAL_SPEED: 'ROTATIONAL_SPEED',
  FLOW_RATE: 'FLOW_RATE',
  VOLUME: 'VOLUME',
  LEVEL: 'LEVEL',
  VISCOSITY: 'VISCOSITY',
  EFFICIENCY: 'EFFICIENCY',
  USAGE: 'USAGE',
  COUNT: 'COUNT',
  DATA_RATE: 'DATA_RATE',
  LOG_DEBUG_MESSAGE: 'LOG_DEBUG_MESSAGE',
} as const;

export type VendorErrorParameter =
  (typeof VendorErrorParameter)[keyof typeof VendorErrorParameter];
